<app-header-one [sticky]="true"></app-header-one>
<!-- <app-header-three [themeLogo]="themeLogo" [sticky]="true"></app-header-three> -->

<!-- Home slider start-->
<section class="p-0">
  <app-slider 
    [sliders]="slider" 
    [textClass]="'text-center'"
    [category]="'fashion'"
    [buttonText]="'Start now'"> 
  </app-slider>
</section>
<!-- Home slider End -->

<!-- collection banner start-->
<section class="pb-0" *ngIf="GalleryList&&GalleryList.length > 1">
  <div class="container">
    <div class="row partition2">
      <div class="col-md-6">
        <a href="{{GalleryList[0].redirectURl}}" >
          <div class="collection-banner p-right text-center">
            <img [src]="GalleryList[0].imageURl" style="max-height: 230px;" class="img-fluid" alt="collection-banner">
            <div class="contain-banner">
              <div>
                <h2>{{lang==='ar-EG'?GalleryList[0].nameAr:GalleryList[0].NameEn}}</h2>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6">
        <a href="{{GalleryList[1].redirectURl}}" >
          <div class="collection-banner p-right text-center">
            <img [src]="GalleryList[1].imageURl"  style="max-height: 230px;"  class="img-fluid" alt="collection-banner">
            <div class="contain-banner">
              <div>
                <h2>{{lang==='ar-EG'?GalleryList[1].nameAr:GalleryList[1].NameEn}}</h2>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>
<!-- collection banner End -->

<!-- Product slider start-->
<div class="title1 section-t-space" *ngIf="WorkshopsList && WorkshopsList.length > 1">
  <!-- <h4>TRAINING COURSES</h4> -->
  <h2 class="title-inner1">{{'top WORKSHOPS'|translate}}</h2>
</div>
<div class="container" *ngIf="WorkshopsList && WorkshopsList.length > 1">
  <div class="row">
    <div class="col-lg-6 offset-lg-3">
      <div class="product-para">
        <p class="text-center">
          {{'The most important workshops at the Islamic Center.'|translate}}        </p>
      </div>
    </div>
  </div>
</div>
<section class="section-b-space p-t-0" *ngIf="WorkshopsList && WorkshopsList.length > 1">
  <div class="container">
    <div class="row">
      <div class="col">
        <owl-carousel-o class="product-4 product-m no-arrow" [options]="ProductSliderConfig">
          <ng-container *ngFor="let workshope of WorkshopsList | slice:0:16">
            <ng-template carouselSlide>
              <div class="product-box">
                <workshops 
                  [workshope]="workshope" 
                  [thumbnail]="true"
                  [cartModal]="true">
                </workshops>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>
<!-- <section class="section-b-space p-t-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <owl-carousel-o class="product-m no-arrow" [options]="ProductSliderConfig">
          <ng-container *ngFor="let product of products | slice:0:16">
            <ng-template carouselSlide>
              <div class="product-box">
                <app-product-box-one 
                  [product]="product" 
                  [currency]="productService?.Currency"
                  [thumbnail]="true"
                  [cartModal]="true">
                </app-product-box-one>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section> -->
<!-- Product slider End -->

<!-- Parallax banner start-->
<section class="p-0" *ngIf="banner&&banner.id>0" >
  <div style="margin-top: 20px;" class="full-banner parallax-banner1 parallax text-center p-left"
    [ngStyle]="{'background-image': 'url('+banner.imageUrl+')'}">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="banner-contain">
            <!-- <h2>1975</h2> -->
            <h3>{{lang==='ar-EG'?banner.titleAr:banner.titleEn}} </h3>
            <h4>{{lang==='ar-EG'?banner.subTitleAr:banner.subTitleEn}} </h4>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
<!-- Parallax banner End -->

<!-- Tab product start-->
<div class="title1 section-t-space">
  <!-- <h4>exclusive products</h4> -->
  <h2 class="title-inner1">{{'Last ACTIVITIES'|translate}}</h2>
</div>
<section class="section-b-space p-t-0">
  <div class="container">
    <div class="row">
      <owl-carousel-o class="product-m no-arrow" [options]="ProductSliderConfig2">
        <ng-container  *ngFor="let Activity of ActivityList">
          <ng-template carouselSlide>
            <div class="product-box">
              <activites 
                [Activity]="Activity" 
                [thumbnail]="true"
                [cartModal]="true">
              </activites>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    
    </div>
  </div>
</section>
<section class="section-b-space p-t-0">
  <div class="container">
    <section class="blog p-t-0">
        <div class="row">
          <div class="col">
            <div class="title1 section-t-space">
              <h4></h4>
              <h2 class="title-inner1">{{"Managers"|translate}}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-blog [blogs]="managers"></app-blog>
          </div>
        </div>
    </section>
  </div>

</section>
<div class="title1 section-t-space">
  <!-- <h4>exclusive products</h4> -->
  <h2 class="title-inner1"><a routerLink="/islamic-center/news" style="color: #222222;">{{'News'|translate}}</a> </h2>
</div>
<section class="section-b-space p-t-0" *ngIf="NewsList&&NewsList.length > 0">
  <div class="container">
    <div class="row">
      <owl-carousel-o class="product-m no-arrow" [options]="ProductSliderConfig3">
        <ng-container  *ngFor="let item of NewsList">
          <ng-template carouselSlide>
            <div class="product-box">
              <news 
                [News]="item" 
                [thumbnail]="true"
                [cartModal]="true">
              </news>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    
    </div>
  </div>
</section>
<!-- <section class="pb-0" *ngIf="rows&&rows.length > 0">
  <div class="container">
    <div class="row partition2">
      <div class="col-md-6" *ngFor="let item of rows">
        <a routerLink="/islamic-center/news-details/{{item.id}}"  >
          <div class="collection-banner p-right text-center">
            <img [src]="item.imageUrl" style="max-height: 230px;" class="img-fluid" alt="collection-banner">
            <div class="contain-banner">
              <div>
                <h2>{{lang==='ar-EG'?item.titleAr:item.titleEn}}</h2>
              </div>
            </div>
          </div>
        </a>
      </div>
 
    </div>
  </div>
</section> -->
<div class="title1 section-t-space" style="margin-bottom: 50px;">
  <!-- <h4>exclusive products</h4> -->
</div>
<!-- <app-newsletter></app-newsletter> -->
<app-footer-one></app-footer-one>

